/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  CustomerCategory,
  CustomerCategoryDisplay,
} from "~/models/customerCategory";

export function displayCustomerCategory(value: string) {
  switch (value) {
    case CustomerCategory.MCC:
      return CustomerCategoryDisplay.MCC;
    case CustomerCategory.MCE:
      return CustomerCategoryDisplay.MCE;
    case CustomerCategory.MCA:
      return CustomerCategoryDisplay.MCA;
    case CustomerCategory.SAAS:
      return CustomerCategoryDisplay.SAAS;
    case CustomerCategory.LANDING_ZONE:
      return CustomerCategoryDisplay.LANDING_ZONE;
    case CustomerCategory.L1:
      return CustomerCategoryDisplay.L1;
    case CustomerCategory.CSM:
      return CustomerCategoryDisplay.CSM;
    case CustomerCategory.ONBOARD:
      return CustomerCategoryDisplay.ONBOARD;
    case CustomerCategory.CPS:
      return CustomerCategoryDisplay.CPS;
    case CustomerCategory.MCDB:
      return CustomerCategoryDisplay.MCDB;
    case CustomerCategory.MCO_OPENSHIFT:
      return CustomerCategoryDisplay.MCO_OPENSHIFT;
    case CustomerCategory.MCO_K8S:
      return CustomerCategoryDisplay.MCO_K8S;
    case CustomerCategory.MFO:
      return CustomerCategoryDisplay.MFO;
    case CustomerCategory.MVM:
      return CustomerCategoryDisplay.MVM;
    case CustomerCategory.SAP:
      return CustomerCategoryDisplay.SAP;

    default:
      return "-";
  }
}
